import styled from "styled-components"

import { Dropdown } from "ggx-componentlibrary/components/dropdown/dropdown.component"

const StyledDropdown = styled(Dropdown)`
  width: 168px;
`

export { StyledDropdown }
